<app-header></app-header>
<ion-content scroll-y="false">
  <div
    class="statements-content gray-content-bg"
    #mainDivScroll
    cdkVirtualScrollingElement
    *ngIf="vm$ | async; let vm"
  >
    <div class="main-header">
      <app-header-filters
        [breadcrumbs]="vm.breadcrumbs"
        [defaultDateFilterId]="FilterIds.statementDate"
        [filters]="vm.filters"
        [filterVm$]="vm$"
        [isLoading]="vm.isInitialLoading"
        [isTouch]="(isTouch$ | async)"
        [isWindows]="platformService?.isWindows()"
        [modalType]="ModalType.arStatement"
        [platformType]="platformService?.platformType"
        [service]="arStatementsService"
        [showQuickDateFilterOption]="true"
        [showResetFilterOption]="true"
        [title]="'i18n.payments.arStatements.title' | translate"
      ></app-header-filters>
    </div>

    <div class="main-content">
      <ion-grid [fixed]="true">
        <div *ngIf="vm.isPayCCAOn" class="payment-callout">
          <div>
            {{ 'i18n.payments.arStatements.readyToMakeAPayment' | translate }}
          </div>
          <ion-button
            class="usf-outline-green-button pay-now"
            data-cy="pay-now-button"
            (click)="payNow()"
          >
            {{ 'i18n.common.payNow' | translate }}
          </ion-button>
        </div>
        <ng-container *ngIf="!vm.isInitialLoading; else isLoading">
          <div
            *ngIf="vm.arStatements.length > 0"
            class="ar-statements-table-header"
          >
            <app-table-header
              *ngIf="isDesktop"
              [dataColumns]="[
            {
              size: '5.5',
              label:
                'i18n.payments.arStatements.tableHeader.customer'
                | translate,
              sortField: HeaderFields.customerName,
              sortDirectionByDefault: SortDirection.ASC,
              dataCyName: 'ar-statements-customer',
            },
            {
              size: '5.5',
              label:
                'i18n.payments.arStatements.tableHeader.statementDate' | translate,
              sortField: HeaderFields.statementDate,
              dataCyName: 'ar-statements-statement-date',
            },
          ]"
              [sortDirection]="sortDirection"
              [sortField]="sortField"
              [isSelectable]="true"
              (clickEmit)="handleSort($event)"
            ></app-table-header>
          </div>
          <div class="ar-statements-rows">
            <cdk-virtual-scroll-viewport
              itemSize="76"
              (scrolledIndexChange)="!vm.isLoading && scrolledIndexChange($event, vm.pageNum, vm.nextPage)"
            >
              <app-ar-statements-row
                *cdkVirtualFor="
              let arStatement of vm.arStatements;
              let i = index;
              trackBy: trackByIdx
              "
                [vm]="arStatement"
                [isDesktop]="isDesktop"
                (arStatementRowClickEmitter)="selectArStatement($event)"
                (moreOptionsClickEmitter)="openMoreOptions($event)"
              ></app-ar-statements-row>
            </cdk-virtual-scroll-viewport>
            <ng-container *ngIf="vm.isLoading">
              <ion-skeleton-text class="item" animated></ion-skeleton-text>
              <ion-skeleton-text class="item" animated></ion-skeleton-text>
              <ion-skeleton-text class="item" animated></ion-skeleton-text>
            </ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="vm.arStatements.length <= 0 && !vm.isLoading">
          <div class="no-info-message">
            <h5 data="no-ar-transactions">
              {{ 'i18n.payments.arStatements.noStatements' | translate }}
            </h5>
          </div>
        </ng-container>
        <ng-template #isLoading>
          <ion-skeleton-text class="item" animated></ion-skeleton-text>
          <ion-skeleton-text class="item" animated></ion-skeleton-text>
          <ion-skeleton-text class="item" animated></ion-skeleton-text>
          <ion-skeleton-text class="item" animated></ion-skeleton-text>
          <ion-skeleton-text class="item" animated></ion-skeleton-text>
          <ion-skeleton-text class="item" animated></ion-skeleton-text>
          <ion-skeleton-text class="item" animated></ion-skeleton-text>
        </ng-template>
      </ion-grid>
    </div>
    <app-footer></app-footer>
  </div>
  <div
    data-cy="ar-statements-actions"
    class="ar-statements-buttons"
    [class.is-touch]="!isDesktop"
  >
    <app-top-button
      [mainScroll]="mainScroll"
      [isMobile]="isMobile"
    ></app-top-button>
    <div class="help-button">
      <img
        data-cy="help-button"
        src="assets/icon/custom-help-tooltip.svg"
        (click)="openHelpModal()"
        alt="help image"
      />
    </div>
  </div>
</ion-content>

<app-selection-banner
  *ngIf="vm$ | async; let vm"
  [class.ion-hide]="vm.countStatementSelected < 1"
  [showMainAction]="true"
  [isDownloadEnabled]="false"
  [countItemsSelected]="vm.countStatementSelected"
  [labelMainActionBtn]="'i18n.common.download' | translate"
  slot="fixed"
  (deselectAllClickEmitter)="clearAllSelections()"
  (selectAllClickEmitter)="selectAllStatements(vm.countStatementSelected)"
  (mainActionClickEmitter)="downloadSelectedStatements(vm.arStatements)"
></app-selection-banner>
